import AppRoutes from "../config/AppRoutes";
import LookingToDoPage from "../pages/LookingToDoPage";
import PreapprovedGetStartedPage from "../pages/PreapprovedGetStartedPage";
import PreapprovedFirstTimePage from "../pages/PreapprovedFirstTimePage";
import PreapprovalApplyNowPage from "../pages/PreapprovalApplyNowPage";
import PreapprovalConfidentNowGoodTimePage from "../pages/PreapprovalConfidentNowGoodTimePage";
import PreapprovalIsItRightTimePage from "../pages/PreapprovalIsItRightTimePage";
import PreapprovalEmotionallyReadyPage from "../pages/PreapprovalEmotionallyReadyPage";
import PreapprovalFinanciallyReadyPage from "../pages/PreapprovalFinanciallyReadyPage";
import PreapprovalHowMuchSpendPage from "../pages/PreapprovalHowMuchSpendPage";
import PreapprovalWhatToDoNextPage from "../pages/PreapprovalWhatToDoNextPage";
import PreapprovalChecklistPage from "../pages/PreapprovalChecklistPage";
import PreapprovalWhatToDoWithCurrentHomePage from "../pages/PreapprovalWhatToDoWithCurrentHomePage";
import PreapprovalCouldBeFirstTimeHomebuyerPage from "../pages/PreapprovalCouldBeFirstTimeHomebuyerPage";
import PreapprovalHowCoordinateBuySellPage from "../pages/PreapprovalHowCoordinateBuySellPage";
import PreapprovalWhatToDoWithSecondHomePage from "../pages/PreapprovalWhatToDoWithSecondHomePage";
import PreapprovalPricePointPage from "../pages/PreapprovalPricePointPage";
import PreapprovalIsRentalWorthItPage from "../pages/PreapprovalIsRentalWorthItPage";
import BuyFirstTimePage from "../pages/BuyFirstTimePage";
import BuySignedContractFirstTimeHomebuyerPage from "../pages/BuySignedContractFirstTimeHomebuyerPage";
import BuyHaveThirtyDaysPage from "../pages/BuyHaveThirtyDaysPage";
import BuyPreApprovalWithUswfPage from "../pages/BuyPreApprovalWithUswfPage";
import BuyPreApprovedApplyNowPage from "../pages/BuyPreApprovedApplyNowPage";
import BuyPreApprovedWithOtherPage from "../pages/BuyPreApprovedWithOtherPage";
import BuyDoYouHavePreapprovalPage from "../pages/BuyDoYouHavePreapprovalPage";
import BuyDoYouWantHypotheticalQuotePage from "../pages/BuyDoYouWantHypotheticalQuotePage";
import BuyDoYouWantToApplyPreapprovalFirstTimePage from "../pages/BuyDoYouWantToApplyPreapprovalFirstTimePage";
import BuySignedContractNotFirstTimeHomebuyerPage from "../pages/BuySignedContractNotFirstTimeHomebuyerPage";
import BuyDoYouWantToApplyForPreapprovalNotFirstTimePage from "../pages/BuyDoYouWantToApplyForPreapprovalNotFirstTimePage";
import BuyDoYouOwnAHomePage from "../pages/BuyDoYouOwnAHomePage";
import BuyHowWillYouCoordinatePage from "../pages/BuyHowWillYouCoordinatePage";
import BuyDoYouWantToFastTrackPage from "../pages/BuyDoYouWantToFastTrackPage";
import BuildDoYouHavePlansPage from "../pages/BuildDoYouHavePlansPage";
import BuildYouWillNeedConstructionLoanPage from "../pages/BuildYouWillNeedConstructionLoanPage";
import BuildYouNeedConstructionToPermanentLoanPage from "../pages/BuildYouNeedConstructionToPermanentLoanPage";
import BuildWhenDoYouPlanToClosePage from "../pages/BuildWhenDoYouPlanToClosePage";
import BuildLetsBuildYourQuotePage from "../pages/BuildLetsBuildYourQuotePage";
import BuildWithinNinetyDaysPage from "../pages/BuildWithinNinetyDaysPage";
import BuildDosAndDontsPage from "../pages/BuildDosAndDontsPage";
import BuildLoanCommitmentPage from "../pages/BuildLoanCommitmentPage";
import BuildWhatNextPage from "../pages/BuildWhatNextPage";
import RefinancePrimaryReasonPage from "../pages/RefinancePrimaryReasonPage";
import RefinanceCashOutCalculatorPage from "../pages/RefinanceCashOutCalculatorPage";
import RefinanceShouldYouRefinancePage from "../pages/RefinanceShouldYouRefinancePage";
import RefinanceWhatNextPage from "../pages/RefinanceWhatNextPage";
import RefinanceIrqAddressPage from "../pages/RefinanceIrqAddressPage";
import RefinanceIrqNotSupportedPage from "../pages/RefinanceIrqNotSupportedPage";
import RefinanceIrqPropertyNotSupportedPage from "../pages/RefinanceIrqPropertyNotSupportedPage";
import RefinanceIrqPrimaryResidencePage from "../pages/RefinanceIrqPrimaryResidencePage";
import RefinanceIrqPropertyTypePage from "../pages/RefinanceIrqPropertyTypePage";
import RefinanceIrqPropertyValuePage from "../pages/RefinanceIrqPropertyValuePage";
import RefinanceIrqExistingBalancePage from "../pages/RefinanceIrqExistingBalancePage";
import RefinanceIrqTakeCashOutPage from "../pages/RefinanceIrqTakeCashOutPage";
import RefinanceIrqHowMuchCashOutPage from "../pages/RefinanceIrqHowMuchCashOutPage";
import RefinanceIrqCreditScorePage from "../pages/RefinanceIrqCreditScorePage";
import RefinanceIrqVeteranPage from "../pages/RefinanceIrqVeteranPage";
import RefinanceIrqSelfEmployedPage from "../pages/RefinanceIrqSelfEmployedPage";
import RefinanceIrqClosingDatePage from "../pages/RefinanceIrqClosingDatePage";
import RefinanceIrqWaiveEscrowPage from "../pages/RefinanceIrqWaiveEscrowPage";
import RefinanceIrqLoanOptionsPage from "../pages/RefinanceIrqLoanOptionsPage";
import RefinanceIrqConfirmationPage from "../pages/RefinanceIrqConfirmationPage";
import RefinanceIrqComparePage from "../pages/RefinanceIrqComparePage";
import BuildIrqAddressPage from "../pages/BuildIrqAddressPage";
import BuildIrqNotSupportedPage from "../pages/BuildIrqNotSupportedPage";
import BuildIrqPropertyNotSupportedPage from "../pages/BuildIrqPropertyNotSupportedPage";
import BuildIrqPrimaryResidencePage from "../pages/BuildIrqPrimaryResidencePage";
import BuildIrqPropertyTypePage from "../pages/BuildIrqPropertyTypePage";
import BuildIrqPropertyValuePage from "../pages/BuildIrqPropertyValuePage";
import BuildIrqDownPaymentPage from "../pages/BuildIrqDownPaymentPage";
import BuildIrqCreditScorePage from "../pages/BuildIrqCreditScorePage";
import BuildIrqVeteranPage from "../pages/BuildIrqVeteranPage";
import RefinanceIrqUsCitizenPage from "../pages/RefinanceIrqUsCitizenPage";
import BuildIrqUsCitizenPage from "../pages/BuildIrqUsCitizenPage";
import BuildIrqSelfEmployedPage from "../pages/BuildIrqSelfEmployedPage";
import BuildIrqRealEstateAgentPage from "../pages/BuildIrqRealEstateAgentPage";
import BuildIrqClosingDatePage from "../pages/BuildIrqClosingDatePage";
import BuildIrqWaiveEscrowPage from "../pages/BuildIrqWaiveEscrowPage";
import BuildIrqLoanOptionsPage from "../pages/BuildIrqLoanOptionsPage";
import BuildIrqConfirmationPage from "../pages/BuildIrqConfirmationPage";
import BuildIrqComparePage from "../pages/BuildIrqComparePage";
import PurchaseIrqAddressPage from "../pages/PurchaseIrqAddressPage";
import PurchaseIrqNotSupportedPage from "../pages/PurchaseIrqNotSupportedPage";
import PurchaseIrqPropertyNotSupportedPage from "../pages/PurchaseIrqPropertyNotSupportedPage";
import PurchaseIrqPrimaryResidencePage from "../pages/PurchaseIrqPrimaryResidencePage";
import PurchaseIrqPropertyTypePage from "../pages/PurchaseIrqPropertyTypePage";
import PurchaseIrqPropertyValuePage from "../pages/PurchaseIrqPropertyValuePage";
import PurchaseIrqDownPaymentPage from "../pages/PurchaseIrqDownPaymentPage";
import PurchaseIrqCreditScorePage from "../pages/PurchaseIrqCreditScorePage";
import PurchaseIrqVeteranPage from "../pages/PurchaseIrqVeteranPage";
import PurchaseIrqUsCitizenPage from "../pages/PurchaseIrqUsCitizenPage";
import PurchaseIrqSelfEmployedPage from "../pages/PurchaseIrqSelfEmployedPage";
import PurchaseIrqRealEstateAgentPage from "../pages/PurchaseIrqRealEstateAgentPage";
import PurchaseIrqForSaleByOwnerPage from "../pages/PurchaseIrqForSaleByOwnerPage";
import PurchaseIrqTitleCompanyPage from "../pages/PurchaseIrqTitleCompanyPage";
import PurchaseIrqAsIsPage from "../pages/PurchaseIrqAsIsPage";
import PurchaseIrqClosingDatePage from "../pages/PurchaseIrqClosingDatePage";
import PurchaseIrqWaiveEscrowPage from "../pages/PurchaseIrqWaiveEscrowPage";
import PurchaseIrqLoanOptionsPage from "../pages/PurchaseIrqLoanOptionsPage";
import PurchaseIrqConfirmationPage from "../pages/PurchaseIrqConfirmationPage";
import PurchaseIrqComparePage from "../pages/PurchaseIrqComparePage";
import PurchaseIrqSeeVaLoanOptionsPage from "../pages/PurchaseIrqSeeVaLoanOptionsPage";
import PurchaseIrqDisabledVeteranPage from "../pages/PurchaseIrqDisabledVeteranPage";
import PurchaseIrqVaLoanBeforePage from "../pages/PurchaseIrqVaLoanBeforePage";
import BuildIrqSeeVaLoanOptionsPage from "../pages/BuildIrqSeeVaLoanOptionsPage";
import BuildIrqDisabledVeteranPage from "../pages/BuildIrqDisabledVeteranPage";
import BuildIrqVaLoanBeforePage from "../pages/BuildIrqVaLoanBeforePage";
import RefinanceIrqSeeVaLoanOptionsPage from "../pages/RefinanceIrqSeeVaLoanOptionsPage";
import RefinanceIrqDisabledVeteranPage from "../pages/RefinanceIrqDisabledVeteranPage";
import RefinanceIrqVaLoanBeforePage from "../pages/RefinanceIrqVaLoanBeforePage";
import FastTrackPage from "../views/FastTrackPage";
import BuildFirstTimePage from "../pages/BuildFirstTimePage";

export default {
  LOOKING_TO_DO_PAGE: {
    url: AppRoutes.LOOKING_TO_DO_PAGE,
    name: "Looking To Do",
    component: LookingToDoPage,
    isNav: 0,
  },
  PREAPPROVED_GET_STARTED_PAGE: {
    url: AppRoutes.PREAPPROVED_GET_STARTED_PAGE,
    name: "PREAPPROVED Get Started",
    component: PreapprovedGetStartedPage,
    isNav: 0,
  },
  PREAPPROVED_FIRST_TIME_PAGE: {
    url: AppRoutes.PREAPPROVED_FIRST_TIME_PAGE,
    name: "PREAPPROVED First Time",
    component: PreapprovedFirstTimePage,
    isNav: 0,
  },
  PREAPPROVAL_APPLY_NOW_PAGE: {
    url: AppRoutes.PREAPPROVAL_APPLY_NOW_PAGE,
    name: "PREAPPROVAL Apply Now",
    component: PreapprovalApplyNowPage,
    isNav: 0,
  },
  PREAPPROVAL_CONFIDENT_NOW_GOOD_TIME_PAGE: {
    url: AppRoutes.PREAPPROVAL_CONFIDENT_NOW_GOOD_TIME_PAGE,
    name: "PREAPPROVAL Confident Now Good Time",
    component: PreapprovalConfidentNowGoodTimePage,
    isNav: 0,
  },
  PREAPPROVAL_IS_IT_RIGHT_TIME_PAGE: {
    url: AppRoutes.PREAPPROVAL_IS_IT_RIGHT_TIME_PAGE,
    name: "PREAPPROVAL Is It Right Time",
    component: PreapprovalIsItRightTimePage,
    isNav: 0,
  },
  PREAPPROVAL_EMOTIONALLY_READY_PAGE: {
    url: AppRoutes.PREAPPROVAL_EMOTIONALLY_READY_PAGE,
    name: "PREAPPROVAL Emotionally Ready",
    component: PreapprovalEmotionallyReadyPage,
    isNav: 0,
  },
  PREAPPROVAL_FINANCIALLY_READY_PAGE: {
    url: AppRoutes.PREAPPROVAL_FINANCIALLY_READY_PAGE,
    name: "PREAPPROVAL Financially Ready",
    component: PreapprovalFinanciallyReadyPage,
    isNav: 0,
  },
  PREAPPROVAL_HOW_MUCH_SPEND_PAGE: {
    url: AppRoutes.PREAPPROVAL_HOW_MUCH_SPEND_PAGE,
    name: "PREAPPROVAL How Much Spend",
    component: PreapprovalHowMuchSpendPage,
    isNav: 0,
  },
  PREAPPROVAL_WHAT_TO_DO_NEXT_PAGE: {
    url: AppRoutes.PREAPPROVAL_WHAT_TO_DO_NEXT_PAGE,
    name: "PREAPPROVAL What To Do Next",
    component: PreapprovalWhatToDoNextPage,
    isNav: 0,
  },
  PREAPPROVAL_CHECKLIST_PAGE: {
    url: AppRoutes.PREAPPROVAL_CHECKLIST_PAGE,
    name: "PREAPPROVAL Checklist",
    component: PreapprovalChecklistPage,
    isNav: 0,
  },
  PREAPPROVAL_WHAT_TO_DO_WITH_CURRENT_HOME_PAGE: {
    url: AppRoutes.PREAPPROVAL_WHAT_TO_DO_WITH_CURRENT_HOME_PAGE,
    name: "PREAPPROVAL What To Do With Current Home",
    component: PreapprovalWhatToDoWithCurrentHomePage,
    isNav: 0,
  },
  PREAPPROVAL_COULD_BE_FIRST_TIME_HOMEBUYER_PAGE: {
    url: AppRoutes.PREAPPROVAL_COULD_BE_FIRST_TIME_HOMEBUYER_PAGE,
    name: "PREAPPROVAL Could Be First Time Homebuyer",
    component: PreapprovalCouldBeFirstTimeHomebuyerPage,
    isNav: 0,
  },
  PREAPPROVAL_HOW_COORDINATE_BUY_SELL_PAGE: {
    url: AppRoutes.PREAPPROVAL_HOW_COORDINATE_BUY_SELL_PAGE,
    name: "PREAPPROVAL How Coordinate Buy Sell",
    component: PreapprovalHowCoordinateBuySellPage,
    isNav: 0,
  },
  PREAPPROVAL_WHAT_TO_DO_WITH_SECOND_HOME_PAGE: {
    url: AppRoutes.PREAPPROVAL_WHAT_TO_DO_WITH_SECOND_HOME_PAGE,
    name: "PREAPPROVAL What To Do With Second Home",
    component: PreapprovalWhatToDoWithSecondHomePage,
    isNav: 0,
  },
  PREAPPROVAL_PRICE_POINT_PAGE: {
    url: AppRoutes.PREAPPROVAL_PRICE_POINT_PAGE,
    name: "PREAPPROVAL Price Point",
    component: PreapprovalPricePointPage,
    isNav: 0,
  },
  PREAPPROVAL_IS_RENTAL_WORTH_IT_PAGE: {
    url: AppRoutes.PREAPPROVAL_IS_RENTAL_WORTH_IT_PAGE,
    name: "PREAPPROVAL Is Rental Worth It",
    component: PreapprovalIsRentalWorthItPage,
    isNav: 0,
  },
  BUY_FIRST_TIME_PAGE: {
    url: AppRoutes.BUY_FIRST_TIME_PAGE,
    name: "BUY First Time",
    component: BuyFirstTimePage,
    isNav: 0,
  },
  BUY_SIGNED_CONTRACT_FIRST_TIME_HOMEBUYER_PAGE: {
    url: AppRoutes.BUY_SIGNED_CONTRACT_FIRST_TIME_HOMEBUYER_PAGE,
    name: "BUY Signed Contract (First Time Homebuyer)",
    component: BuySignedContractFirstTimeHomebuyerPage,
    isNav: 0,
  },
  BUY_HAVE_THIRTY_DAYS_PAGE: {
    url: AppRoutes.BUY_HAVE_THIRTY_DAYS_PAGE,
    name: "BUY Have Thirty Days",
    component: BuyHaveThirtyDaysPage,
    isNav: 0,
  },
  BUY_PRE_APPROVAL_WITH_USWF_PAGE: {
    url: AppRoutes.BUY_PRE_APPROVAL_WITH_USWF_PAGE,
    name: "BUY Pre Approval With USWF",
    component: BuyPreApprovalWithUswfPage,
    isNav: 0,
  },
  BUY_PRE_APPROVED_APPLY_NOW_PAGE: {
    url: AppRoutes.BUY_PRE_APPROVED_APPLY_NOW_PAGE,
    name: "BUY Pre Approved Apply Now",
    component: BuyPreApprovedApplyNowPage,
    isNav: 0,
  },
  BUY_PRE_APPROVED_WITH_OTHER_PAGE: {
    url: AppRoutes.BUY_PRE_APPROVED_WITH_OTHER_PAGE,
    name: "BUY Pre Approved With Other",
    component: BuyPreApprovedWithOtherPage,
    isNav: 0,
  },
  BUY_DO_YOU_HAVE_PREAPPROVAL_PAGE: {
    url: AppRoutes.BUY_DO_YOU_HAVE_PREAPPROVAL_PAGE,
    name: "BUY Do You Have Preapproval",
    component: BuyDoYouHavePreapprovalPage,
    isNav: 0,
  },
  BUY_DO_YOU_WANT_HYPOTHETICAL_QUOTE_PAGE: {
    url: AppRoutes.BUY_DO_YOU_WANT_HYPOTHETICAL_QUOTE_PAGE,
    name: "BUY Do You Want Hypothetical Quote",
    component: BuyDoYouWantHypotheticalQuotePage,
    isNav: 0,
  },
  BUY_DO_YOU_WANT_TO_APPLY_PREAPPROVAL_FIRST_TIME_PAGE: {
    url: AppRoutes.BUY_DO_YOU_WANT_TO_APPLY_PREAPPROVAL_FIRST_TIME_PAGE,
    name: "BUY Do You Want To Apply Preapproval (First Time)",
    component: BuyDoYouWantToApplyPreapprovalFirstTimePage,
    isNav: 0,
  },
  BUY_SIGNED_CONTRACT_NOT_FIRST_TIME_HOMEBUYER_PAGE: {
    url: AppRoutes.BUY_SIGNED_CONTRACT_NOT_FIRST_TIME_HOMEBUYER_PAGE,
    name: "BUY Signed Contract (Not First Time Homebuyer)",
    component: BuySignedContractNotFirstTimeHomebuyerPage,
    isNav: 0,
  },
  BUY_DO_YOU_WANT_TO_APPLY_FOR_PREAPPROVAL_NOT_FIRST_TIME_PAGE: {
    url: AppRoutes.BUY_DO_YOU_WANT_TO_APPLY_FOR_PREAPPROVAL_NOT_FIRST_TIME_PAGE,
    name: "BUY Do You Want to Apply For Preapproval (Not First Time)",
    component: BuyDoYouWantToApplyForPreapprovalNotFirstTimePage,
    isNav: 0,
  },
  BUY_DO_YOU_OWN_A_HOME_PAGE: {
    url: AppRoutes.BUY_DO_YOU_OWN_A_HOME_PAGE,
    name: "BUY Do You Own A Home",
    component: BuyDoYouOwnAHomePage,
    isNav: 0,
  },
  BUY_HOW_WILL_YOU_COORDINATE_PAGE: {
    url: AppRoutes.BUY_HOW_WILL_YOU_COORDINATE_PAGE,
    name: "BUY How Will You Coordinate",
    component: BuyHowWillYouCoordinatePage,
    isNav: 0,
  },
  BUY_DO_YOU_WANT_TO_FAST_TRACK_PAGE: {
    url: AppRoutes.BUY_DO_YOU_WANT_TO_FAST_TRACK_PAGE,
    name: "BUY Do You Want To Fast Track",
    component: BuyDoYouWantToFastTrackPage,
    isNav: 0,
  },
  BUILD_FIRST_TIME_PAGE: {
    url: AppRoutes.BUILD_FIRST_TIME_PAGE,
    name: "BUILD IRQ First Time",
    component: BuildFirstTimePage,
    isNav: 0,
  },
  BUILD_DO_YOU_HAVE_PLANS_PAGE: {
    url: AppRoutes.BUILD_DO_YOU_HAVE_PLANS_PAGE,
    name: "BUILD Do You Have Plans",
    component: BuildDoYouHavePlansPage,
    isNav: 0,
  },
  BUILD_YOU_WILL_NEED_CONSTRUCTION_LOAN_PAGE: {
    url: AppRoutes.BUILD_YOU_WILL_NEED_CONSTRUCTION_LOAN_PAGE,
    name: "BUILD You Will Need Construction Loan",
    component: BuildYouWillNeedConstructionLoanPage,
    isNav: 0,
  },
  BUILD_YOU_NEED_CONSTRUCTION_TO_PERMANENT_LOAN_PAGE: {
    url: AppRoutes.BUILD_YOU_NEED_CONSTRUCTION_TO_PERMANENT_LOAN_PAGE,
    name: "BUILD You Need Construction to Permanent Loan",
    component: BuildYouNeedConstructionToPermanentLoanPage,
    isNav: 0,
  },
  BUILD_WHEN_DO_YOU_PLAN_TO_CLOSE_PAGE: {
    url: AppRoutes.BUILD_WHEN_DO_YOU_PLAN_TO_CLOSE_PAGE,
    name: "BUILD When Do You Plan to Close",
    component: BuildWhenDoYouPlanToClosePage,
    isNav: 0,
  },
  BUILD_LETS_BUILD_YOUR_QUOTE_PAGE: {
    url: AppRoutes.BUILD_LETS_BUILD_YOUR_QUOTE_PAGE,
    name: "BUILD Lets Build Your Quote",
    component: BuildLetsBuildYourQuotePage,
    isNav: 0,
  },
  BUILD_WITHIN_NINETY_DAYS_PAGE: {
    url: AppRoutes.BUILD_WITHIN_NINETY_DAYS_PAGE,
    name: "BUILD Within Ninety Days",
    component: BuildWithinNinetyDaysPage,
    isNav: 0,
  },
  BUILD_DOS_AND_DONTS_PAGE: {
    url: AppRoutes.BUILD_DOS_AND_DONTS_PAGE,
    name: "BUILD Dos and Donts",
    component: BuildDosAndDontsPage,
    isNav: 0,
  },
  BUILD_LOAN_COMMITMENT_PAGE: {
    url: AppRoutes.BUILD_LOAN_COMMITMENT_PAGE,
    name: "BUILD Loan Commitment",
    component: BuildLoanCommitmentPage,
    isNav: 0,
  },
  BUILD_WHAT_NEXT_PAGE: {
    url: AppRoutes.BUILD_WHAT_NEXT_PAGE,
    name: "BUILD What Next",
    component: BuildWhatNextPage,
    isNav: 0,
  },
  REFINANCE_PRIMARY_REASON_PAGE: {
    url: AppRoutes.REFINANCE_PRIMARY_REASON_PAGE,
    name: "REFINANCE Primary Reason",
    component: RefinancePrimaryReasonPage,
    isNav: 0,
  },
  REFINANCE_CASH_OUT_CALCULATOR_PAGE: {
    url: AppRoutes.REFINANCE_CASH_OUT_CALCULATOR_PAGE,
    name: "REFINANCE Cash Out Calculator",
    component: RefinanceCashOutCalculatorPage,
    isNav: 0,
  },
  REFINANCE_SHOULD_YOU_REFINANCE_PAGE: {
    url: AppRoutes.REFINANCE_SHOULD_YOU_REFINANCE_PAGE,
    name: "REFINANCE Should You Refinance",
    component: RefinanceShouldYouRefinancePage,
    isNav: 0,
  },
  REFINANCE_WHAT_NEXT_PAGE: {
    url: AppRoutes.REFINANCE_WHAT_NEXT_PAGE,
    name: "REFINANCE What Next",
    component: RefinanceWhatNextPage,
    isNav: 0,
  },
  REFINANCE_IRQ_ADDRESS_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_ADDRESS_PAGE,
    name: "REFINANCE IRQ Address",
    component: RefinanceIrqAddressPage,
    isNav: 0,
  },
  REFINANCE_IRQ_NOT_SUPPORTED_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_NOT_SUPPORTED_PAGE,
    name: "REFINANCE IRQ Not Supported",
    component: RefinanceIrqNotSupportedPage,
    isNav: 0,
  },
  REFINANCE_IRQ_PROPERTY_NOT_SUPPORTED_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_PROPERTY_NOT_SUPPORTED_PAGE,
    name: "REFINANCE IRQ Property Not Supported",
    component: RefinanceIrqPropertyNotSupportedPage,
    isNav: 0,
  },
  REFINANCE_IRQ_PRIMARY_RESIDENCE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_PRIMARY_RESIDENCE_PAGE,
    name: "REFINANCE IRQ Primary Residence",
    component: RefinanceIrqPrimaryResidencePage,
    isNav: 0,
  },
  REFINANCE_IRQ_PROPERTY_TYPE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_PROPERTY_TYPE_PAGE,
    name: "REFINANCE IRQ Property Type",
    component: RefinanceIrqPropertyTypePage,
    isNav: 0,
  },
  REFINANCE_IRQ_PROPERTY_VALUE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_PROPERTY_VALUE_PAGE,
    name: "REFINANCE IRQ Property Value",
    component: RefinanceIrqPropertyValuePage,
    isNav: 0,
  },
  REFINANCE_IRQ_EXISTING_BALANCE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_EXISTING_BALANCE_PAGE,
    name: "REFINANCE IRQ Existing Balance",
    component: RefinanceIrqExistingBalancePage,
    isNav: 0,
    props: { id: "refinanceIrq" },
  },
  REFINANCE_IRQ_TAKE_CASH_OUT_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_TAKE_CASH_OUT_PAGE,
    name: "REFINANCE IRQ Take Cash Out",
    component: RefinanceIrqTakeCashOutPage,
    isNav: 0,
  },
  REFINANCE_IRQ_HOW_MUCH_CASH_OUT_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_HOW_MUCH_CASH_OUT_PAGE,
    name: "REFINANCE IRQ How Much Cash Out",
    component: RefinanceIrqHowMuchCashOutPage,
    isNav: 0,
    props: { id: "refinanceIrq" },
  },
  REFINANCE_IRQ_CREDIT_SCORE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_CREDIT_SCORE_PAGE,
    name: "REFINANCE IRQ Credit Score",
    component: RefinanceIrqCreditScorePage,
    isNav: 0,
  },
  REFINANCE_IRQ_VETERAN_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_VETERAN_PAGE,
    name: "REFINANCE IRQ Veteran",
    component: RefinanceIrqVeteranPage,
    isNav: 0,
  },
  REFINANCE_IRQ_SEE_VA_LOAN_OPTIONS_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_SEE_VA_LOAN_OPTIONS_PAGE,
    name: "REFINANCE IRQ See VA Loan Options",
    component: RefinanceIrqSeeVaLoanOptionsPage,
    isNav: 0,
  },
  REFINANCE_IRQ_DISABLED_VETERAN_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_DISABLED_VETERAN_PAGE,
    name: "REFINANCE IRQ Disabled veteran",
    component: RefinanceIrqDisabledVeteranPage,
    isNav: 0,
  },
  REFINANCE_IRQ_VA_LOAN_BEFORE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_VA_LOAN_BEFORE_PAGE,
    name: "REFINANCE IRQ Had VA loan before",
    component: RefinanceIrqVaLoanBeforePage,
    isNav: 0,
  },
  REFINANCE_IRQ_SELF_EMPLOYED_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_SELF_EMPLOYED_PAGE,
    name: "REFINANCE IRQ Self Employed",
    component: RefinanceIrqSelfEmployedPage,
    isNav: 0,
  },
  REFINANCE_IRQ_CLOSING_DATE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_CLOSING_DATE_PAGE,
    name: "REFINANCE IRQ Closing Date",
    component: RefinanceIrqClosingDatePage,
    isNav: 0,
  },
  REFINANCE_IRQ_WAIVE_ESCROW_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_WAIVE_ESCROW_PAGE,
    name: "REFINANCE IRQ Waive Escrow",
    component: RefinanceIrqWaiveEscrowPage,
    isNav: 0,
  },
  REFINANCE_IRQ_LOAN_OPTIONS_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_LOAN_OPTIONS_PAGE,
    name: "REFINANCE IRQ Loan Options",
    component: RefinanceIrqLoanOptionsPage,
    isNav: 0,
  },
  REFINANCE_IRQ_CONFIRMATION_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_CONFIRMATION_PAGE,
    name: "REFINANCE IRQ Confirmation",
    component: RefinanceIrqConfirmationPage,
    isNav: 0,
  },
  REFINANCE_IRQ_COMPARE_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_COMPARE_PAGE,
    name: "REFINANCE IRQ Compare",
    component: RefinanceIrqComparePage,
    isNav: 0,
  },
  BUILD_IRQ_ADDRESS_PAGE: {
    url: AppRoutes.BUILD_IRQ_ADDRESS_PAGE,
    name: "BUILD IRQ Address",
    component: BuildIrqAddressPage,
    isNav: 0,
  },
  BUILD_IRQ_NOT_SUPPORTED_PAGE: {
    url: AppRoutes.BUILD_IRQ_NOT_SUPPORTED_PAGE,
    name: "BUILD IRQ Not Supported",
    component: BuildIrqNotSupportedPage,
    isNav: 0,
  },
  BUILD_IRQ_PROPERTY_NOT_SUPPORTED_PAGE: {
    url: AppRoutes.BUILD_IRQ_PROPERTY_NOT_SUPPORTED_PAGE,
    name: "BUILD IRQ Property Not Supported",
    component: BuildIrqPropertyNotSupportedPage,
    isNav: 0,
  },
  BUILD_IRQ_PRIMARY_RESIDENCE_PAGE: {
    url: AppRoutes.BUILD_IRQ_PRIMARY_RESIDENCE_PAGE,
    name: "BUILD IRQ Primary Residence",
    component: BuildIrqPrimaryResidencePage,
    isNav: 0,
  },
  BUILD_IRQ_PROPERTY_TYPE_PAGE: {
    url: AppRoutes.BUILD_IRQ_PROPERTY_TYPE_PAGE,
    name: "BUILD IRQ Property Type",
    component: BuildIrqPropertyTypePage,
    isNav: 0,
  },
  BUILD_IRQ_PROPERTY_VALUE_PAGE: {
    url: AppRoutes.BUILD_IRQ_PROPERTY_VALUE_PAGE,
    name: "BUILD IRQ Property Value",
    component: BuildIrqPropertyValuePage,
    isNav: 0,
  },
  BUILD_IRQ_DOWN_PAYMENT_PAGE: {
    url: AppRoutes.BUILD_IRQ_DOWN_PAYMENT_PAGE,
    name: "BUILD IRQ Down Payment",
    component: BuildIrqDownPaymentPage,
    isNav: 0,
    props: { id: "buildIrq" },
  },
  BUILD_IRQ_CREDIT_SCORE_PAGE: {
    url: AppRoutes.BUILD_IRQ_CREDIT_SCORE_PAGE,
    name: "BUILD IRQ Credit Score",
    component: BuildIrqCreditScorePage,
    isNav: 0,
  },
  BUILD_IRQ_VETERAN_PAGE: {
    url: AppRoutes.BUILD_IRQ_VETERAN_PAGE,
    name: "BUILD IRQ Veteran",
    component: BuildIrqVeteranPage,
    isNav: 0,
  },
  BUILD_IRQ_SEE_VA_LOAN_OPTIONS_PAGE: {
    url: AppRoutes.BUILD_IRQ_SEE_VA_LOAN_OPTIONS_PAGE,
    name: "BUILD IRQ See VA Loan Options",
    component: BuildIrqSeeVaLoanOptionsPage,
    isNav: 0,
  },
  BUILD_IRQ_DISABLED_VETERAN_PAGE: {
    url: AppRoutes.BUILD_IRQ_DISABLED_VETERAN_PAGE,
    name: "BUILD IRQ Disabled veteran",
    component: BuildIrqDisabledVeteranPage,
    isNav: 0,
  },
  BUILD_IRQ_VA_LOAN_BEFORE_PAGE: {
    url: AppRoutes.BUILD_IRQ_VA_LOAN_BEFORE_PAGE,
    name: "BUILD IRQ Had VA loan before",
    component: BuildIrqVaLoanBeforePage,
    isNav: 0,
  },
  REFINANCE_IRQ_US_CITIZEN_PAGE: {
    url: AppRoutes.REFINANCE_IRQ_US_CITIZEN_PAGE,
    name: "REFINANCE IRQ Citizen",
    component: RefinanceIrqUsCitizenPage,
    isNav: 0,
  },
  BUILD_IRQ_US_CITIZEN_PAGE: {
    url: AppRoutes.BUILD_IRQ_US_CITIZEN_PAGE,
    name: "BUILD IRQ Citizen",
    component: BuildIrqUsCitizenPage,
    isNav: 0,
  },
  BUILD_IRQ_SELF_EMPLOYED_PAGE: {
    url: AppRoutes.BUILD_IRQ_SELF_EMPLOYED_PAGE,
    name: "BUILD IRQ Self Employed",
    component: BuildIrqSelfEmployedPage,
    isNav: 0,
  },
  BUILD_IRQ_REAL_ESTATE_AGENT_PAGE: {
    url: AppRoutes.BUILD_IRQ_REAL_ESTATE_AGENT_PAGE,
    name: "BUILD IRQ Real Estate Agent",
    component: BuildIrqRealEstateAgentPage,
    isNav: 0,
  },
  BUILD_IRQ_CLOSING_DATE_PAGE: {
    url: AppRoutes.BUILD_IRQ_CLOSING_DATE_PAGE,
    name: "BUILD IRQ Closing Date",
    component: BuildIrqClosingDatePage,
    isNav: 0,
  },
  BUILD_IRQ_WAIVE_ESCROW_PAGE: {
    url: AppRoutes.BUILD_IRQ_WAIVE_ESCROW_PAGE,
    name: "BUILD IRQ Waive Escrow",
    component: BuildIrqWaiveEscrowPage,
    isNav: 0,
  },
  BUILD_IRQ_LOAN_OPTIONS_PAGE: {
    url: AppRoutes.BUILD_IRQ_LOAN_OPTIONS_PAGE,
    name: "BUILD IRQ Loan Options",
    component: BuildIrqLoanOptionsPage,
    isNav: 0,
  },
  BUILD_IRQ_CONFIRMATION_PAGE: {
    url: AppRoutes.BUILD_IRQ_CONFIRMATION_PAGE,
    name: "BUILD IRQ Confirmation",
    component: BuildIrqConfirmationPage,
    isNav: 0,
  },
  FAST_TRACK_PAGE: {
    url: process.env.REACT_APP_ROUTE_PREFIX + "/fasttrack",
    name: "Fast Track",
    component: FastTrackPage,
    isNav: 0,
  },
  BUILD_IRQ_COMPARE_PAGE: {
    url: AppRoutes.BUILD_IRQ_COMPARE_PAGE,
    name: "BUILD IRQ Compare",
    component: BuildIrqComparePage,
    isNav: 0,
  },
  PURCHASE_IRQ_ADDRESS_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_ADDRESS_PAGE,
    name: "PURCHASE IRQ Address",
    component: PurchaseIrqAddressPage,
    isNav: 0,
  },
  PURCHASE_IRQ_NOT_SUPPORTED_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_NOT_SUPPORTED_PAGE,
    name: "PURCHASE IRQ Not Supported",
    component: PurchaseIrqNotSupportedPage,
    isNav: 0,
  },
  PURCHASE_IRQ_PROPERTY_NOT_SUPPORTED_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_PROPERTY_NOT_SUPPORTED_PAGE,
    name: "PURCHASE IRQ Property Not Supported",
    component: PurchaseIrqPropertyNotSupportedPage,
    isNav: 0,
  },
  PURCHASE_IRQ_PRIMARY_RESIDENCE_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_PRIMARY_RESIDENCE_PAGE,
    name: "PURCHASE IRQ Primary Residence",
    component: PurchaseIrqPrimaryResidencePage,
    isNav: 0,
  },
  PURCHASE_IRQ_PROPERTY_TYPE_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_PROPERTY_TYPE_PAGE,
    name: "PURCHASE IRQ Property Type",
    component: PurchaseIrqPropertyTypePage,
    isNav: 0,
  },
  PURCHASE_IRQ_PROPERTY_VALUE_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_PROPERTY_VALUE_PAGE,
    name: "PURCHASE IRQ Property Value",
    component: PurchaseIrqPropertyValuePage,
    isNav: 0,
  },
  PURCHASE_IRQ_DOWN_PAYMENT_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_DOWN_PAYMENT_PAGE,
    name: "PURCHASE IRQ Down Payment",
    component: PurchaseIrqDownPaymentPage,
    isNav: 0,
    props: { id: "purchaseIrq" },
  },
  PURCHASE_IRQ_CREDIT_SCORE_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_CREDIT_SCORE_PAGE,
    name: "PURCHASE IRQ Credit Score",
    component: PurchaseIrqCreditScorePage,
    isNav: 0,
  },
  PURCHASE_IRQ_VETERAN_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_VETERAN_PAGE,
    name: "PURCHASE IRQ Veteran",
    component: PurchaseIrqVeteranPage,
    isNav: 0,
  },
  PURCHASE_IRQ_SEE_VA_LOAN_OPTIONS_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_SEE_VA_LOAN_OPTIONS_PAGE,
    name: "PURCHASE IRQ See VA Loan Options",
    component: PurchaseIrqSeeVaLoanOptionsPage,
    isNav: 0,
  },
  PURCHASE_IRQ_DISABLED_VETERAN_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_DISABLED_VETERAN_PAGE,
    name: "PURCHASE IRQ Disabled veteran",
    component: PurchaseIrqDisabledVeteranPage,
    isNav: 0,
  },
  PURCHASE_IRQ_VA_LOAN_BEFORE_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_VA_LOAN_BEFORE_PAGE,
    name: "PURCHASE IRQ Had VA loan before",
    component: PurchaseIrqVaLoanBeforePage,
    isNav: 0,
  },
  PURCHASE_IRQ_US_CITIZEN_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_US_CITIZEN_PAGE,
    name: "PURCHASE IRQ US Citizen",
    component: PurchaseIrqUsCitizenPage,
    isNav: 0,
  },
  PURCHASE_IRQ_SELF_EMPLOYED_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_SELF_EMPLOYED_PAGE,
    name: "PURCHASE IRQ Self Employed",
    component: PurchaseIrqSelfEmployedPage,
    isNav: 0,
  },
  PURCHASE_IRQ_REAL_ESTATE_AGENT_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_REAL_ESTATE_AGENT_PAGE,
    name: "PURCHASE IRQ Real Estate Agent",
    component: PurchaseIrqRealEstateAgentPage,
    isNav: 0,
  },
  PURCHASE_IRQ_FOR_SALE_BY_OWNER_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_FOR_SALE_BY_OWNER_PAGE,
    name: "PURCHASE IRQ For Sale By Owner",
    component: PurchaseIrqForSaleByOwnerPage,
    isNav: 0,
  },
  PURCHASE_IRQ_TITLE_COMPANY_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_TITLE_COMPANY_PAGE,
    name: "PURCHASE IRQ Title Company",
    component: PurchaseIrqTitleCompanyPage,
    isNav: 0,
  },
  PURCHASE_IRQ_AS_IS_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_AS_IS_PAGE,
    name: "PURCHASE IRQ As Is",
    component: PurchaseIrqAsIsPage,
    isNav: 0,
  },
  PURCHASE_IRQ_CLOSING_DATE_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_CLOSING_DATE_PAGE,
    name: "PURCHASE IRQ Closing Date",
    component: PurchaseIrqClosingDatePage,
    isNav: 0,
  },
  PURCHASE_IRQ_WAIVE_ESCROW_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_WAIVE_ESCROW_PAGE,
    name: "PURCHASE IRQ Waive Escrow",
    component: PurchaseIrqWaiveEscrowPage,
    isNav: 0,
  },
  PURCHASE_IRQ_LOAN_OPTIONS_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_LOAN_OPTIONS_PAGE,
    name: "PURCHASE IRQ Loan Options",
    component: PurchaseIrqLoanOptionsPage,
    isNav: 0,
  },
  PURCHASE_IRQ_CONFIRMATION_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_CONFIRMATION_PAGE,
    name: "PURCHASE IRQ Confirmation",
    component: PurchaseIrqConfirmationPage,
    isNav: 0,
  },
  PURCHASE_IRQ_COMPARE_PAGE: {
    url: AppRoutes.PURCHASE_IRQ_COMPARE_PAGE,
    name: "PURCHASE IRQ Compare",
    component: PurchaseIrqComparePage,
    isNav: 0,
  },
};
